export const tooltipStyle = {
  contentStyle: {
    background: "var(--tooltip-bg)",
    border: "1px solid var(--tooltip-border)",
    borderRadius: 12,
    backdropFilter: "blur(12px)",
    fontSize: 12,
    color: "var(--foreground)",
  },
  labelStyle: { color: "var(--foreground)", fontWeight: 600 },
};

export const axisTick = { fontSize: 11, fill: "var(--axis-text)" };
export const gridStroke = "var(--grid-line)";